import { Field, FieldCheckbox, FieldInput, FieldLabel, FieldTextarea } from '@ibe/ui';
import { Controller, type Control, type FieldErrors, type UseFormRegister } from 'react-hook-form';

import { type InclusionFormInput } from '../api/schemas.js';

export function InclusionFields({
  register,
  errors,
  control,
}: {
  readonly register: UseFormRegister<InclusionFormInput>;
  readonly errors: FieldErrors<InclusionFormInput>;
  readonly control: Control<InclusionFormInput>;
}): React.JSX.Element {
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        <Field error={errors.code?.message} required>
          <FieldLabel>Code</FieldLabel>
          <FieldInput autoComplete="off" placeholder="BREAKFAST" {...register('code')} />
        </Field>
        <Field error={errors.name?.message} required>
          <FieldLabel>Name</FieldLabel>
          <FieldInput autoComplete="off" placeholder="Breakfast" {...register('name')} />
        </Field>
      </div>
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        <Field error={errors.currency?.message} required>
          <FieldLabel>Currency</FieldLabel>
          <FieldInput autoComplete="off" placeholder="USD" {...register('currency')} />
        </Field>
        <Field error={errors.unitCost?.message} required>
          <FieldLabel>Unit cost</FieldLabel>
          <FieldInput autoComplete="off" placeholder="12.50" {...register('unitCost')} />
        </Field>
      </div>
      <Field error={errors.description?.message}>
        <FieldLabel>Description</FieldLabel>
        <FieldTextarea {...register('description')} />
      </Field>
      <Field error={errors.fulfillmentDepartment?.message}>
        <FieldLabel>Fulfillment department</FieldLabel>
        <FieldInput
          autoComplete="off"
          placeholder="Housekeeping"
          {...register('fulfillmentDepartment')}
        />
      </Field>
      <Field error={errors.defaultInstructions?.message}>
        <FieldLabel>Default instructions</FieldLabel>
        <FieldTextarea {...register('defaultInstructions')} />
      </Field>
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        <Field error={errors.requiresFulfillment?.message}>
          <Controller
            control={control}
            name="requiresFulfillment"
            render={({ field }) => (
              <FieldCheckbox
                checked={field.value}
                onCheckedChange={field.onChange}
                onBlur={field.onBlur}
                disabled={field.disabled ?? false}
              >
                Requires fulfillment
              </FieldCheckbox>
            )}
          />
        </Field>
        <Field error={errors.isActive?.message}>
          <Controller
            control={control}
            name="isActive"
            render={({ field }) => (
              <FieldCheckbox
                checked={field.value}
                onCheckedChange={field.onChange}
                onBlur={field.onBlur}
                disabled={field.disabled ?? false}
              >
                Active
              </FieldCheckbox>
            )}
          />
        </Field>
      </div>
    </div>
  );
}
